export * from "./useProductsDetails";
